import React from "react";
import moment from "moment";
import { DatePickerContainer, FilterText, TableHeader } from "./styles";
import { DatePicker } from "src/components/atoms/DatePicker";
import { DATEPICKER_VARIANT } from "src/components/atoms/DatePicker/types";
import { AttendanceLogsHeaderProps } from "./types";
import Button from "src/components/Button";

const AttendanceLogsHeader = ({
  newDate,
  setNewDate,
  fieldName,
  datePickerRef,
  maxDate,
  minDate,
  disabled,
}: AttendanceLogsHeaderProps) => {
  const dateFormat = "MM/DD/YYYY";

  return (
    <TableHeader>
      <DatePickerContainer>
        <FilterText>Filter by Date:</FilterText>
        <DatePicker
          variant={DATEPICKER_VARIANT.DATE}
          onChange={(value: string) => {
            if (!value) {
              setNewDate(null);
              return;
            }

            const parsedDate = moment(value, dateFormat, true);
            setNewDate(parsedDate.isValid() ? parsedDate.toDate() : null);
          }}
          value={newDate && moment(newDate).isValid() ? moment(newDate).format(dateFormat) : ""}
          name={fieldName}
          ref={datePickerRef}
          maxDate={maxDate}
          minDate={minDate}
          disabled={disabled}
        />
        {newDate && moment(newDate).isValid() && (
          <Button variant="small-secondary" text="Clear" onClick={() => setNewDate(null)} disabled={disabled} />
        )}
      </DatePickerContainer>
    </TableHeader>
  );
};

export default AttendanceLogsHeader;
